import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
  import { useVuetify } from '../composables/useVuetify';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'QButton',
  props: {
    color: { type: String, default: 'primary' },
    type: { type: String as PropType<'primary' | 'secondary' | 'text'>, default: 'primary' },
    icon: { type: String, default: '' },
  },
  setup(__props) {

const props = __props

_useCssVars((_vm, _setup) => ({
  "5ee2274b": (_setup.textColor)
}))

  const { getTextColor } = useVuetify()

  

  const primaryProps = {
    depressed: true,
  }

  const secondaryProps = {
    outlined: true,
  }

  const textProps = {
    text: true,
  }

  const typeProps = computed(() => {
    switch (props.type) {
      case 'primary':
        return primaryProps
      case 'secondary':
        return secondaryProps
      case 'text':
        return textProps
      default:
        return {}
    }
  })

  const textColor = computed(() => getTextColor(props.color))

  const dividerColor = computed(() => {
	return props.type === 'primary'
		? textColor.value
		: props.color
  })

return { __sfc: true,getTextColor, props, primaryProps, secondaryProps, textProps, typeProps, textColor, dividerColor }
}

})